import {store} from '@/store'
import AuthRequest from '@/model/request/AuthRequest'
import Responsavel from '@/model/resource/Responsavel'
import {UFInitial} from '@/enums/UFInitial'

export const isLogged = () => store.getters['auth/isLogged'] as boolean
export const getToken = () => store.getters['auth/token'] as string
export const getQueryToken = () => store.getters['auth/queryToken'] as string
export const getResponsavel = () => store.getters['auth/responsavel'] as Responsavel
export const getRegraExibicaoGrupoEconomico = () => store.getters['auth/regraExibicaoGrupoEconomico'] as boolean

export const auth = () => store.dispatch('auth/auth')
export const signIn = (request: AuthRequest) => store.dispatch('auth/signIn', request)
export const signOut = () => store.dispatch('auth/signOut')

export const SPINEL_INFO = {
    cnpj: '08158714000134',
    razaoSocial: 'SPINEL COMERCIO E EXPORTACAO DE ARTESANATOS LTDA',
    endereco: {
        cep: '05443-001',
        logradouro: 'Rua Natingui',
        nro: '2041',
        bairro: 'Vila Madalena',
        cidade: 'São Paulo',
        uf: UFInitial.SP,
        complemento: '',
    },
}

export function isPiquetur() {
  const ROOT_CNPJ_PIQUETUR = '04045101'

  if (isLogged()) {
    const resp = getResponsavel()
    if (resp.cnpj.split('').splice(0, 8).join('') === ROOT_CNPJ_PIQUETUR) return true
  }
  return false
}

export function isCielo() {
    const ROOT_CNPJ_CIELO = '01027058'

    if (isLogged()) {
        const resp = getResponsavel()
        if (resp.cnpj.split('').splice(0, 8).join('') === ROOT_CNPJ_CIELO) return true
    }
    return false
}

export function isBulkLog() {
    const ROOT_CNPJ_BULKLOG = '32705849'
    if (isLogged()) {
        const resp = getResponsavel()
        if (resp.cnpj.split('').splice(0, 8).join('') === ROOT_CNPJ_BULKLOG) return true
    }
    return false
}

export function isHelm() {
    const ROOT_HELM_CNPJ = '47176755'
    if (isLogged()) {
        const resp = getResponsavel()
        if (resp.cnpj.split('').splice(0, 8).join('') === ROOT_HELM_CNPJ) return true
    }
    return false
}

export function isAGCO() {
    const ROOT_AGCO_CNPJ = '55962369'
    if (isLogged()) {
        const resp = getResponsavel()
        if (resp.cnpj.split('').splice(0, 8).join('') === ROOT_AGCO_CNPJ) return true
    }
    return false
}

export function isIBMP() {
    const ROOT_IBMP_CNPJ = '03585986'
    if (isLogged()) {
        const resp = getResponsavel()
        if (resp.cnpj.split('').splice(0, 8).join('') === ROOT_IBMP_CNPJ) return true
    }
    return false
}

export function getPermitirRoterizacao() {

    if (isLogged()) {
        const resp = getResponsavel()

        return resp.permitirRoterizacao
    }
    return false
}

export function getPermitirChecklist() {

    if (isLogged()) {
        const resp = getResponsavel()

        return resp.permitirChecklist || resp.permitirChecklistComponente
    }
    return false
}

export function getTypeReportChecklist() {

    if (isLogged()) {
        const resp = getResponsavel()

        if (resp.permitirChecklist && !resp.permitirChecklistComponente) {
            return 1
        }

        if (resp.permitirChecklistComponente && !resp.permitirChecklist) {
            return 2
        }
    }

    return 0
}

export function getPermitirContraSenha() {
    if (isLogged()) {
        const  resp = getResponsavel()

        return resp.envioDeContraSenhaCnpj || resp.envioDeContraSenhaCpf
    }
}

export function getPermitirDevolverNota() {
  if (isLogged()) {
    const resp = getResponsavel()

    return resp.permitirDevolverNota
  }

  return false
}

export function getPermitirDevolverNotaFinalizadaParaNaoIniciada() {
    if (isLogged()) {
        const resp = getResponsavel()

        return resp.permitirDevolverNotaFinalizadaParaNaoIniciada
    }

    return false
}

export function getPermitirFotoInicioCarga() {
    if (isLogged()) {
        const resp = getResponsavel()

        return resp.permitirFotoInicioCarga
    }

    return false
}

export function getClienteExportacao() {
    if (isLogged()) {
        const resp = getResponsavel()

        return resp.exportacao
    }

    return false
}

export function getPermitirTipoFinalizacaoSucesso() {
    if (isLogged()) {
        const resp = getResponsavel()

        return resp.tipoFinalizacaoSucesso
    }

    return false
}

export function getPermitirIntegracaoCorreios() {
    if (isLogged()) {
        const resp = getResponsavel()

        return resp.integracaoCorreios
    }

    return false
}

export function getExibirMapaTelaSacPrivado() {
    if (isLogged()) {
        const resp = getResponsavel()

        return resp.exibirMapaTelaSacPrivado
    }

    return false
}

export function isAtlasOrAssociates() {

    if (isLogged()) {
        const resp = getResponsavel()
        const listaRaizCnpjs = ['00028986', '60664828', '95420790', '98831267']
        const rootLoggedDoc = resp.cnpj.split('').splice(0, 8).join('')
        return listaRaizCnpjs.some((it) => it.startsWith(rootLoggedDoc))
    }

    return false
}

export function isBoticario() {
    const ROOT_CNPJ_BOTICARIO = '11137051000186'
    if (isLogged()) {
        const resp = getResponsavel()
        return ROOT_CNPJ_BOTICARIO === resp.cnpj
    }
    return false
}

export function isSpinel() {
    if (isLogged()) {
        const resp = getResponsavel()
        return SPINEL_INFO.cnpj === resp.cnpj
    }
    return false
}

export function getPermitirAlertaNotaAtraso() {
    if (isLogged()) {
        const resp = getResponsavel()

        return resp.permitirAlertaNotaAtraso
    }

    return false
}

export function getShowNotificacaoSmsAtlas() {
    if (isLogged()) {
        const resp = getResponsavel()

        return resp.permitirNotificacaoSmsAtlas && isAtlasOrAssociates()
    }
}

export function getShowNotificacaoEmailAtlas() {
    if (isLogged()) {
        const resp = getResponsavel()

        return resp.permitirNotificacaoEmailAtlas && isAtlasOrAssociates()
    }
}

export function getPermitirDataReal() {
    if (isLogged()) {
        const resp = getResponsavel()

        return resp.permitirDataReal
    }
}
export function isAtlasLondrina() {
    const ROOT_CNPJ_ATLAS_LONDRINA = '00028986014753'
    if (isLogged()) {
        const resp = getResponsavel()
        return ROOT_CNPJ_ATLAS_LONDRINA === resp.cnpj
    }
    return false
}

export function isIvecoCnh() {
  if (isLogged()) {
    const resp = getResponsavel()
    const listaRaizCnpjs = ['01844555', '14928557', '36519422']
    const rootLoggedDoc = resp.cnpj.split('').splice(0, 8).join('')
    return listaRaizCnpjs.some((it) => it.startsWith(rootLoggedDoc))
  }
  return false
}

export function isGroupThatCannotUseAuditValidation() {
    if (isLogged()) {
        const resp = getResponsavel()
        const listaRaizCnpjs = ['07067233', '17055496', '24957933', '00489676', '00028986', '12053556']
        const rootLoggedDoc = resp.cnpj.split('').splice(0, 8).join('')
        return !listaRaizCnpjs.some((it) => it.startsWith(rootLoggedDoc))
    }

    return true
}

export function isInterlog() {
    const ROOT_CNPJ_INTERLOG = '08957212'
    if (isLogged()) {
        const resp = getResponsavel()
        if (resp.cnpj.split('').splice(0, 8).join('') === ROOT_CNPJ_INTERLOG) return true
    }
}
